import app from '@/app';

/* @ngInject */
const resource = abstractResource => abstractResource('criteria-set');

app.factory('CriteriaSet', resource);
